import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import ReactHtmlParser from "react-html-parser";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import API from "api";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";
import { toast } from "react-toastify";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Header from "./Header";
import { FaWhatsapp } from "react-icons/fa";

import Frame1 from "../../assets/images/public-pages/Frame1.svg";
import Frame2 from "../../assets/images/public-pages/Frame2.svg";
import Frame3 from "../../assets/images/public-pages/Frame3.svg";
import Frame4 from "../../assets/images/public-pages/Frame4.svg";
import Frame5 from "../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../assets/images/public-pages/Frame19.svg";
import Frame20 from "../../assets/images/public-pages/Frame11.svg";
import Work from "assets/images/public-pages/green-work.svg";
import WorkBalance from "assets/images/public-pages/green-balance.svg";
import Idea from "assets/images/public-pages/green-idea-2.svg";
import Collab from "assets/images/public-pages/green-collab.svg";
import Globe from "assets/images/public-pages/green-globe.svg";
import CheckIcon from "assets/images/public-pages/Checkmark.svg";
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import { Modal } from "react-bootstrap";
import CustomPhoneInput from "components/PublicPagesReusable/CustomPhoneInput";

const ExamVoucher = React.memo(function ExamVoucher() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false);

  const EMAIL_REGEX =
    /^[a-zA-Z0-9]([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
  // Allow Unicode letters (\p{L}) + combining marks (\p{M}) so diacritics like
  // é/ñ survive whether they're precomposed or decomposed, plus space, apostrophe, hyphen.
  const NAME_DISALLOWED_REGEX = /[^\p{L}\p{M} '\-]/gu;
  const NAME_ALLOWED_REGEX = /^[\p{L}\p{M} '\-]+$/u;

  const normalizeName = (value) => (value || "").toString().normalize("NFC");
  const [showContactModal, setShowContactModal] = useState(false);
  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center">
        Book Your PTE Exam at
        <br />
        <span className="fw-600 text-success">India's Best Price.</span>
      </h1>
    );
  };

  const connectToWhastup = () => {
    const phoneNumber = import.meta.env.VITE_WHATSAPP_NUMBER || "919056611913"; // Replace with your target number
    const url = `https://wa.me/${phoneNumber}?text=Hello%2C%20can%20I%20get%20the%20voucher%20details%3F`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const callToPhone = () => {
    const phoneNumber = import.meta.env.VITE_WHATSAPP_NUMBER || "919056611913";
    window.open(`tel:${phoneNumber}`, "_self");
  };

  const data = {
    badge: "Australia’s Leading English Proficiency Centre",
    title: heroWorkTitle,
    subtitle:
      "Language Academy is now offering genuine PTE exam vouchers at ₹16,400 — saving you ₹2,500 on the standard Pearson price.<br/><br/>🇮🇳 Valid for PTE tests in India only  ·  Instant digital delivery",
    platformArray: [
      { icon: CheckIcon, title: "PTE Academic" },
      { icon: CheckIcon, title: "PTE Core" },
      { icon: CheckIcon, title: "PTE Academic UKVI" },
    ],
    btnText: "Book on WhatsApp",
    btnLink: connectToWhastup,
    // btn_outline: "Call +91 90566 11913",
    btn_outline:'Contact Us'
  };

  const images = [
    {
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },
    {
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },
    {
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    },
    {
      src: Frame20,
      alt: "score-20",
    },
  ];
  const cardData = [
    {
      icon: Work,
      title: "Genuine Discount",
      content:
        "Save ₹2,500 on the standard Pearson price — our authorised partnership passes the savings directly to you.",
    },
    {
      icon: Collab,
      title: "100% Authentic",
      content:
        "Every voucher is sourced directly from Pearson. Fully legitimate, verifiable at all test centres.",
    },
    {
      icon: Globe,
      title: "AI Portal Bonus",
      content:
        "Every voucher purchase unlocks an exclusive discount on our AI-Powered PTE Practice Portal.",
    },
    {
      icon: Idea,
      title: "Personal Support",
      content:
        "Our team is available on WhatsApp to guide you through the entire booking process.",
    },
    {
      icon: WorkBalance,
      title: "All Centres Covered",
      content:
        "Valid at 100+ Pearson VUE test centres across India. Pick any city, any date.",
    },
  ];

  const examCards = [
    {
      badge: "Most Popular",
      title: "PTE",
      highlight: "Academic",
      description:
        "The gold standard for English proficiency. Accepted for Australian PR, student visas, and thousands of universities worldwide.",
      features: [
        "Australian skilled migration (PR)",
        "University admissions worldwide",
        "Student & graduate visa applications",
        "Scored 10–90 on all four skills",
      ],
    },

    {
      badge: "Canada & Work Visas",
      title: "PTE",
      highlight: "Core",
      description:
        "Designed for work and life migration — particularly for Canadian immigration pathways including Express Entry and PNP.",
      features: [
        "Canadian Express Entry & PNP",
        "Work permit applications",
        "Focused on real-world communication",
        "Shorter, more accessible test format",
      ],
    },

    {
      badge: "UK Visas",
      title: "PTE Academic",
      highlight: "UKVI",
      description:
        "The UK Home Office–approved SELT. Required for most UK visa applications including Skilled Worker and Student visas.",
      features: [
        "UK Skilled Worker Visa",
        "UK Student Visa (Tier 4)",
        "UK Home Office approved (SELT)",
        "Same format as PTE Academic",
      ],
    },
  ];

  const preprationWorkTitle = () => {
    return (
      <h3 className="top-section-text mb-4 white FS40FW600">
        <span className="text-success FS40FW600">Book Your Exam in</span>
        <br />4 Simple Steps
      </h3>
    );
  };

  const preprationWorkCards = [
    {
      title: "Contact Us",
      text: "WhatsApp or call us on +91 90566 11913. Tell us which exam type you need.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Belief.svg",
      badge: "Step 1",
      borderColor: "#FFFFFF3D",
    },
    {
      title: "Make Payment",
      text: "Pay ₹16,400 via UPI, NEFT, or our secure payment link. Receipt sent instantly.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Decode.svg",
      badge: "Step 2",
      borderColor: "#FFFFFF3D",
    },
    {
      title: "Receive Voucher",
      text: "Your unique voucher code is delivered to your WhatsApp within minutes of payment.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Template.svg",
      badge: "Step 3",
      borderColor: "#FFFFFF3D",
    },
    {
      title: "Book Your Test",
      text: "Go to pearsonvue.com, enter your voucher, and pick your test centre and date. Done!",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Algorithm.svg",
      badge: "Step 4",
      borderColor: "#FFFFFF3D",
    },
    // {
    //   title: "Re-Code Confidence",
    //   text: "Boost performance by preparing systematically for English exams. Stay focused and practice regularly!",
    //   color: "#0286FF",
    //   img: "/images/web-new-images/emojis/Updated/Confidence.svg",
    //   badge: "Step 5",
    //   borderColor:'#FFFFFF3D'
    // },
  ];

  const faqQuestions = [
    {
      question: " Is this voucher 100% genuine?",
      answer:
        "Yes. Language Academy is an authorised Pearson partner. Every voucher is a genuine Pearson voucher — fully verifiable at all official Pearson VUE test centres across India.",
    },
    {
      question: "Which exam types are available?",
      answer:
        "All three — PTE Academic, PTE Core, and PTE Academic UKVI — are available at ₹16,400. Just let us know which one you need when you contact us on WhatsApp.",
    },
    {
      question: "How quickly will I receive my voucher?",
      answer:
        "Instantly. Once payment is confirmed, your voucher is delivered to your WhatsApp within minutes. No waiting, no delays.",
    },
    {
      question: "How long is the voucher valid for?",
      answer:
        "Pearson exam vouchers are typically valid for 12 months from the issue date. We'll confirm the exact expiry when we send your voucher.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept UPI (GPay, PhonePe, Paytm), NEFT/IMPS bank transfer, and our secure online payment link. Details are shared via WhatsApp after you reach out.",
    },
    {
      question: "Can I also get PTE coaching through Language Academy?",
      answer:
        "Absolutely! LA has been helping students ace PTE and NAATI for 8+ years across 11+ locations. Ask us about our full coaching packages and AI practice portal when you reach out.",
    },
  ];
  const validateField = (field, value) => {
    switch (field) {
      case "fullName": {
        const v = normalizeName(value).trim();
        if (!v) return "Name is required.";
        if (!NAME_ALLOWED_REGEX.test(v)) {
          return "Please use letters, spaces, apostrophes, or hyphens only.";
        }
        return "";
      }
      case "email": {
        const v = (value || "").toString().trim();
        if (!v) return "Email is required.";
        if (!EMAIL_REGEX.test(v) || /\.\./.test(v.split("@")[0]))
          return "Please enter a valid email address.";
        return "";
      }
      case "phone": {
        const v = (value || "").toString().trim();
        if (!v) return "Phone Number is required.";
        if (!isValidPhoneNumber(v)) {
          return "Please enter a valid phone number for the selected country.";
        }
        return "";
      }
      case "message":
        if (!(value || "").toString().trim()) return "Message is required.";
        return "";
      default:
        return "";
    }
  };

  const setField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      // clear the error as soon as the user starts fixing it
      setErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    }
  };
  const handleChange = (field) => (e) => setField(field, e.target.value);
  const handleNameChange = (e) =>
    setField(
      "fullName",
      normalizeName(e.target.value).replace(NAME_DISALLOWED_REGEX, ""),
    );
  const handleBlur = (field) => () => {
    const message = validateField(field, formData[field]);
    setErrors((prev) => {
      const next = { ...prev };
      if (message) next[field] = message;
      else delete next[field];
      return next;
    });
  };
  const handlePhoneChange = (value) => setField("phone", value);

  const validateAll = () => {
    const next = {};
    Object.keys(formData).forEach((field) => {
      const message = validateField(field, formData[field]);
      if (message) next[field] = message;
    });
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    if (submittingRef.current) return; // synchronous block — runs before re-render

    if (!validateAll()) return;

    submittingRef.current = true;
    setSubmitting(true);

    try {
      const res = await API({
        method: "POST",
        url: "post/contact",
        data: {
          name: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          message: `Get my PTE voucher : ${formData.message}`,
        },
      });
      if (res?.status === 200) {
        toast.success(
          res?.data?.response?.message ||
            "Thanks! Our team will contact you shortly.",
        );
        setFormData({ fullName: "", email: "", phone: "", message: "" });
        setErrors({});
        setShowContactModal(false);

      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.log(err);
      
      if (err?.response?.status === 422 && err.response.data?.errors) {
        const serverErrors = err.response.data.errors;
        const mapped = {};
        if (serverErrors.name) mapped.fullName = serverErrors.name[0];
        if (serverErrors.email) mapped.email = serverErrors.email[0];
        if (serverErrors.phone) mapped.phone = serverErrors.phone[0];
        if (serverErrors.message) mapped.message = serverErrors.message[0];
        setErrors((prev) => ({ ...prev, ...mapped }));
      } else {
        toast.error("Something went wrong. Please try again.2");
      }
    } finally {
      submittingRef.current = false;
      setSubmitting(false);
    }
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Language Academy</title>
        <meta name="twitter:title" content="Language Academy" />
        <meta property="og:title" content="Language Academy" />
      </Helmet>
      <Header />

      <section className="new-design">
        <section
          className={`new-updated-hero-section position-relative noc-branches-banner contact-hero-section pte-scoring`}
        >
          <div className="hero-section text-white position-relative overflow-hidden">
            <div className="hero-bg" />

            <div className="custom-container w-50 position-relative z-2 py-3 mt-5 px-0">
              {/* LEFT */}
              <div className="d-flex flex-column align-items-center justify-content-center mb-4 mb-lg-0">
                <span className="students-stat mb-2 mb-sm-3 d-inline-block text-center">
                  {data?.badge}
                </span>

                {data?.title && data.title()}

                <p
                  className="mb-3 FS20FW500 fw-400 text-center w-75"
                  style={{ color: "rgba(222, 222, 222, 1)" }}
                >
                  {data?.subtitle && ReactHtmlParser(data?.subtitle)}
                </p>
                <div>
                  <div className="d-flex flex-wrap gap-3 justify-content-start">
                    {data.platformArray?.map((academy, index) => (
                      <div className="platform-item" key={index}>
                        <CardPlatform
                          text={academy.title}
                          icon={academy.icon}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex flex-column flex-xl-row gap-2 gap-sm-3 mt-5">
                  {data?.btnText && (
                    <>
                      <button
                        className={`FS17FW500 align-items-center card-btn d-flex fw-700 gap-2 justify-content-center plus-sans primary-btn to-unset-transform`}
                        onClick={data?.btnLink}
                      >
                        {" "}
                        <FaWhatsapp />
                        {data?.btnText}
                        <img
                          src={`/images/web-new-images/new-dark-arrow.svg`}
                          alt="Register Now"
                        />
                      </button>
                    </>
                  )}
                  {data.btn_outline && (
                    <button
                      className="border-btn gap-2 primary-btn d-flex align-items-center"
                      // onClick={callToPhone}
                      onClick={() => setShowContactModal(true)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_7617_42963)">
                          <path
                            d="M10.5353 4.5C11.2678 4.64292 11.9411 5.00119 12.4688 5.52895C12.9966 6.05671 13.3549 6.72995 13.4978 7.4625M10.5353 1.5C12.0572 1.66908 13.4765 2.35063 14.56 3.43276C15.6435 4.51488 16.3268 5.93326 16.4978 7.455M7.66803 10.3973C6.76684 9.49612 6.05525 8.47714 5.53325 7.38992C5.48835 7.2964 5.4659 7.24965 5.44866 7.19048C5.38736 6.98021 5.43139 6.72202 5.5589 6.54395C5.59478 6.49384 5.63765 6.45097 5.72338 6.36524C5.98558 6.10303 6.11669 5.97193 6.2024 5.84009C6.52565 5.34293 6.52565 4.70199 6.2024 4.20482C6.11669 4.07299 5.98559 3.94189 5.72338 3.67968L5.57723 3.53353C5.17865 3.13495 4.97936 2.93566 4.76532 2.8274C4.33965 2.6121 3.83695 2.6121 3.41128 2.8274C3.19724 2.93566 2.99795 3.13495 2.59937 3.53353L2.48114 3.65176C2.08393 4.04897 1.88532 4.24758 1.73363 4.51761C1.56532 4.81724 1.4443 5.28261 1.44532 5.62627C1.44624 5.93598 1.50632 6.14765 1.62647 6.57098C2.2722 8.84603 3.49056 10.9928 5.28154 12.7838C7.07253 14.5748 9.2193 15.7931 11.4943 16.4389C11.9177 16.559 12.1293 16.6191 12.4391 16.62C12.7827 16.621 13.2481 16.5 13.5477 16.3317C13.8177 16.18 14.0164 15.9814 14.4136 15.5842L14.5318 15.466C14.9304 15.0674 15.1297 14.8681 15.2379 14.654C15.4532 14.2284 15.4532 13.7257 15.2379 13.3C15.1297 13.086 14.9304 12.8867 14.5318 12.4881L14.3856 12.3419C14.1234 12.0797 13.9923 11.9486 13.8605 11.8629C13.3633 11.5397 12.7224 11.5397 12.2252 11.8629C12.0934 11.9486 11.9623 12.0797 11.7001 12.3419C11.6144 12.4277 11.5715 12.4705 11.5214 12.5064C11.3433 12.6339 11.0851 12.678 10.8749 12.6167C10.8157 12.5994 10.7689 12.577 10.6754 12.5321C9.58819 12.0101 8.56921 11.2985 7.66803 10.3973Z"
                            stroke="#94C23C"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_7617_42963">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {data.btn_outline}
                      <img
                        src={`/images/web-new-images/new-green-arrow.png`}
                        alt="Register Now"
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className={`stats-bar mt-3 mt-sm-4 mt-md-5 mb-0 d-flex flex-column flex-lg-row flex-wrap justify-content-between gap-3 w-75 plus-sans`}
            style={{ background: "#fff" }}
          >
            <div className="custom-container m-4 p-3">
              <div>
                <div className="align-items-center justify-content-between row">
                  <div className="col-lg-4">
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                      <span className="text-decoration-line-through text-gray-pricing FS20FW500">
                        ₹18,900
                      </span>

                      <span
                        className="badge-rounded-box FS20FW500"
                        style={{
                          "--bg-color": "#FFE2E2",
                          "--text-color": "#FF3131",
                          "--total-padding": "4px 12px",
                        }}
                      >
                        Standard Price
                      </span>
                    </div>

                    <div className="d-flex flex-wrap align-items-end gap-2">
                      <h1 className="top-section-text FS48 fw-800 mb-0">
                        ₹16,400
                      </h1>

                      <span className="text-gray-pricing FS16FW500 mb-2">
                        Our Price
                      </span>
                    </div>

                    <div className="mt-2">
                      <span
                        className="badge-rounded-box FS20FW500 width-fit-content"
                        style={{
                          "--bg-color": "#E3FFE2",
                          "--text-color": "#48A75C",
                          "--total-padding": "4px 12px",
                        }}
                      >
                        ✓ Save ₹2,500
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-3 mt-4 mt-lg-0 d-flex flex-column align-items-lg-end align-items-start">
                    <span
                      className="badge-rounded-box FS20FW500 width-fit-content ms-lg-auto"
                      style={{
                        "--bg-color": "#FFF8E2",
                        "--text-color": "#825219",
                        "--total-padding": "4px 12px",
                        border: "1px solid #825219",
                      }}
                    >
                      • LIMITED TIME
                    </span>

                    <p className="text-gray-pricing mt-2 mb-0 text-lg-end text-start FS20FW500">
                      Price valid while vouchers are available. Book early to
                      secure yours.
                    </p>
                  </div>
                </div>

                <hr
                  style={{
                    height: "2px",
                    borderWidth: 0,
                    backgroundColor: "#00000012",
                  }}
                />
                <div className="row align-items-center g-3 justify-content-between">
                  <div className="col-lg-7">
                    <div className="d-flex flex-wrap gap-2">
                      <span className="badge-rounded-box">
                        <img src={CheckIcon} alt="Check box" /> PTE Academic
                      </span>

                      <span className="badge-rounded-box">
                        <img src={CheckIcon} alt="Check box" /> PTE Core
                      </span>

                      <span className="badge-rounded-box">
                        <img src={CheckIcon} alt="Check box" /> PTE Academic
                        UKVI
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-5 d-flex justify-content-lg-end justify-content-center">
                    <button
                      className={`FS17FW500 align-items-center d-flex fw-700 gap-2 justify-content-center plus-sans primary-btn to-unset-transform`}
                      onClick={data?.btnLink}
                    >
                      {" "}
                      <FaWhatsapp />
                      Get Your Voucher Now
                      <img
                        src={`/images/web-new-images/new-dark-arrow.svg`}
                        alt="Register Now"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="fame-wall off-white voucher-cards">
          <div className="w-75 mx-auto my-5">
            <div
              className="d-flex flex-wrap justify-content-between align-items-center"
              style={{
                background: "#F0FFEB",
                padding: "24px 44px",
                borderRadius: "48px",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <span className="check-icon">
                  <img src={CheckIcon} alt="Check box" />
                </span>
                <span
                  className="plus-sans FS16FW500 fw-600"
                  style={{ color: "#525252" }}
                >
                  100% Authentic & Verified
                </span>
              </div>

              <div className="d-flex align-items-center gap-2">
                <span className="check-icon">
                  <img src={CheckIcon} alt="Check box" />
                </span>
                <span
                  className="plus-sans FS16FW500 fw-600"
                  style={{ color: "#525252" }}
                >
                  Authorised Source
                </span>
              </div>

              <div className="d-flex align-items-center gap-2">
                <span className="check-icon">
                  <img src={CheckIcon} alt="Check box" />
                </span>
                <span
                  className="plus-sans FS16FW500 fw-600"
                  style={{ color: "#525252" }}
                >
                  Instant Delivery
                </span>
              </div>

              <div className="d-flex align-items-center gap-2">
                <span className="check-icon">
                  <img src={CheckIcon} alt="Check box" />
                </span>
                <span
                  className="plus-sans FS16FW500 fw-600"
                  style={{ color: "#525252" }}
                >
                  All India Test Centres
                </span>
              </div>
            </div>
          </div>
          <ReusableHomePageSlider
            images={images}
            BottomBtns={"Try Calculator Now"}
            btnLink="/pte-score-calculator"
            img="/images/web-new-images/new-dark-arrow.svg"
          />
        </div>

        <section className="py-5">
          <div className="custom-container">
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="hero-title FS40FW600 text-center">
                Why People{" "}
                <span className="text-success FS40FW600">
                  Love Booking With Us
                </span>
              </h2>

              <p
                className="text-gray-pricing FS20FW500 mb-0 mx-auto mt-3"
                style={{ maxWidth: "550px" }}
              >
                We’re not just selling a voucher — we’re invested in your
                success from registration to result day.
              </p>
            </div>

            {/* First row : 3 cards */}
            <div className="row g-4 justify-content-center">
              {cardData.slice(0, 3).map((item, index) => (
                <div className="col-12 col-md-6 col-lg-4" key={index}>
                  <SkillCard card={item} index={index} />
                </div>
              ))}
            </div>

            {/* Second row : 2 centered cards */}
            <div className="row g-4 justify-content-center mt-1">
              {cardData.slice(3).map((item, index) => (
                <div className="col-12 col-md-6 col-lg-4" key={index}>
                  <SkillCard card={item} index={index} />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-5">
          <div className="custom-container">
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="hero-title FS40FW600 text-center">
                Three Exam Types,{" "}
                <span className="text-success FS40FW600">One Great Price</span>
              </h2>

              <p
                className="text-gray-pricing FS20FW500 mb-0 mx-auto mt-3"
                style={{ maxWidth: "550px" }}
              >
                Whether you're applying for PR, a student visa, or UK entry — we
                have the right voucher for you.
              </p>
            </div>
          </div>
          <div className="py-5">
            <div className="custom-container">
              <div className="row g-4">
                {examCards.map((card, index) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 plus-sans"
                    key={index}
                  >
                    <div
                      className="overflow-hidden h-100 shadow-sm"
                      style={{
                        borderRadius: "24px",
                        border: "1px solid rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      {/* Top Dark Header */}
                      <div className="p-4" style={{ background: "#080F1E" }}>
                        <span
                          className="d-inline-block FS16FW500 px-3 py-2 mb-3 width-fit-content m-0"
                          style={{
                            background: "#FFFFFF17",
                            color: "#FFFFFF",
                            borderRadius: "20px",
                          }}
                        >
                          {card.badge}
                        </span>

                        <h2 className="hero-title FS24FW500 text-start text-white fw-700 m-0">
                          {card.title}{" "}
                          <span className="text-success FS24FW500 fst-italic fw-700">
                            {card.highlight}
                          </span>
                        </h2>
                      </div>

                      {/* Content */}
                      <div className="bg-white p-4 h-100">
                        <p
                          className="mb-4 FS16FW500"
                          style={{
                            lineHeight: "28px",
                            color: "#383838",
                          }}
                        >
                          {card.description}
                        </p>

                        <ul className="feature-list-price-new p-0 m-0">
                          {card.features.map((item, i) => (
                            <li
                              key={i}
                              className="FS16FW500 justify-content-start align-items-center"
                              style={{
                                fontFamily: "DM Sans",
                                color: "#525252",
                              }}
                            >
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <CtaBanner
          title="Free Portal Discount With"
          highlight="Every Voucher"
          subTitle={
            "Every PTE Exam Voucher purchase automatically unlocks a special discount on our AI-Powered PTE Practice Portal — trusted by 50,000+ students, with real-exam simulations, score predictions, and personalised feedback."
          }
          buttonText="Book Free Consultation"
          onClick={() => {
            const modal = new window.bootstrap.Modal(
              document.getElementById("staticBackdrop"),
            );
            modal.show();
          }}
          btnText="Take Free Mock Test"
          btnTextClick="/auth/register"
          rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
        />

        <SkillAreas
          skillAreaTitle={preprationWorkTitle}
          skillSubtitle="<span>The entire process takes under 10 minutes — from first contact to receiving your voucher.</span>"
          lifestyleCards={preprationWorkCards}
          className="my-5"
          img="/images/web-new-images/new-dark-arrow.svg"
          sliders={4.2}
        />

        <FaqSection questions={faqQuestions} />
        <Modal
          show={showContactModal}
          onHide={() => {
            setFormData({ fullName: "", email: "", phone: "", message: "" });
            setErrors({});
            setShowContactModal(false)
          }}
          centered
          size="lg"
        >
          <Modal.Header style={{ padding: "0px" }}>
            <div className="d-flex justify-content-end align-items-center p-2">
              <button
                onClick={() => {
                  setFormData({ fullName: "", email: "", phone: "", message: "" });
                  setErrors({});
                  setShowContactModal(false)
                }}
                className="modal-close-btn"
              >
                ×
              </button>
            </div>
          </Modal.Header>
          <Modal.Body className="p-0">
            <form
              className="pte-consultation__form new-design"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="audio-transcript-text p-0 border-0 mt-0">
                <div></div>
                <p className="FS28 fw-600" style={{ color: "#19181C" }}>
                  Send Us a Message
                </p>
                <span className="FS15FW400">
                  Fill out the form below and we'll get back to you within 24
                  hours.
                </span>
                <hr />
              </div>

              <div className="pte-consultation__row gap-3">
                <label className="pte-consultation__field">
                  <span className="pte-consultation__label">Full Name</span>
                  <input
                    type="text"
                    className="pte-consultation__input"
                    placeholder="Enter name"
                    value={formData.fullName}
                    onChange={handleNameChange}
                    onBlur={handleBlur("fullName")}
                    aria-invalid={!!errors.fullName}
                    maxLength={30}
                  />
                  {errors.fullName && (
                    <span className="pte-consultation__error">
                      {errors.fullName}
                    </span>
                  )}
                </label>
                <label className="pte-consultation__field">
                  <span className="pte-consultation__label">Email Address</span>
                  <input
                    type="email"
                    className="pte-consultation__input"
                    placeholder="Enter email address"
                    value={formData.email}
                    onChange={handleChange("email")}
                    onBlur={handleBlur("email")}
                    aria-invalid={!!errors.email}
                  />
                  {errors.email && (
                    <span className="pte-consultation__error">
                      {errors.email}
                    </span>
                  )}
                </label>
              </div>

              <div className="pte-consultation__row">
                <div
                  className={`pte-consultation__field${errors.phone ? " pte-consultation__field--invalid" : ""}`}
                >
                  <span className="pte-consultation__label">Phone Number</span>
                  <CustomPhoneInput
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    onBlur={handleBlur("phone")}
                  />
                  {errors.phone && (
                    <span className="pte-consultation__error">
                      {errors.phone}
                    </span>
                  )}
                </div>
              </div>

              <label
                className="pte-consultation__field"
                style={{ flex: "none" }}
              >
                <span className="pte-consultation__label">Your Message</span>
                <textarea
                  className="pte-consultation__input"
                  placeholder="Tells us about your goals..."
                  value={formData.message}
                  onChange={handleChange("message")}
                  onBlur={handleBlur("message")}
                  aria-invalid={!!errors.message}
                  rows={4}
                  style={{
                    height: "auto",
                    minHeight: "120px",
                    resize: "vertical",
                  }}
                />
                {errors.message && (
                  <span className="pte-consultation__error">
                    {errors.message}
                  </span>
                )}
              </label>

              <div
                className={`pte-consultation__submit-wrap${submitting ? " pte-consultation__submit-wrap--disabled" : ""}`}
              >
                <ButtonComp
                  btnText={submitting ? "Sending..." : "Send My Enquiry"}
                  img="/images/web-new-images/new-dark-arrow.svg"
                  link={submitting ? () => {} : handleSubmit}
                />
              </div>
              {/* <p className="FS14FW600 fw-400 mb-0" style={{ color: "#929498" }}>
            We respect your privacy. Your details will never be shared.
          </p> */}
            </form>
          </Modal.Body>
        </Modal>

        {/* <AppBannerCustom
          appName="PTE"
          description="PTE PRACTICE"
          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
        /> */}
        <section className="naati-hero-section bottom-section-radius custom-container mt-5">
          <div className="px-3 px-md-4 px-lg-5 hero-container py-5">
            <div className="row align-items-center g-5">
              {/* Left side - Text + Stats */}
              <div className="col-lg-6 text-center text-lg-start">
                <h3 className="top-section-text FS40FW600 mb-4">
                  Ready To Secure{" "}
                  <span className="text-success FS40FW600">Your Success</span>
                </h3>

                <p className="lead-text FS20FW500 mb-4">
                  Don't let a busy lifestyle delay your Australian permanent
                  residency dreams or global opportunities.
                </p>
                <p className="lead-text FS20FW500 mb-4">
                  Download the Language Academy apps today and Join 50K+ of
                  successful students' who've earned their goals through smart,
                  flexible preparation.
                </p>

                <div className="download-buttons mb-5 d-flex flex-wrap justify-content-center justify-content-lg-start gap-3">
                  <a
                    className="downlaod-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={import.meta.env.VITE_PTE_ANDROID_APP_URL}
                  >
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a
                    className="downlaod-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={import.meta.env.VITE_PTE_IOS_APP_URL}
                  >
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>

                <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                  <div className="avatars d-flex">
                    <img
                      src="/images/web-new-images/new-content-slider/User-01.svg"
                      alt="user"
                      className="avatar rounded-circle"
                    />
                    <img
                      src="/images/web-new-images/new-content-slider/Pritam.svg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                    <img
                      src="/images/web-new-images/new-content-slider/Karthik-B.svg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                    <img
                      src="/images/web-new-images/new-content-slider/RamimRahman-demo.svg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                    <img
                      src="/images/web-new-images/new-content-slider/SapnaPandey-demo.svg"
                      alt="user"
                      className="avatar rounded-circle ms-n3"
                    />
                  </div>
                  <span className="join-text FS20FW500 fw-600">
                    Join 50K+ Students'
                  </span>
                </div>
              </div>

              {/* Right side - Phones mockup */}
              <div className="col-lg-6">
                <div className="phones-container position-relative text-center">
                  <img
                    src="/images/web-new-images/emojis/Updated/Contact-pte-app.png"
                    alt="NAATI CCL App - Mock Test"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </React.Fragment>
  );
});

const CardPlatform = ({ text, icon }) => {
  return (
    <div
      className="badge-rounded-box d-flex align-items-center justify-content-center h-100"
      style={{
        "--bg-color": "#FFFFFF1A",
        "--text-color": "#FFFFFF",
        "--total-padding": "8px 12px",
      }}
    >
      <img src={icon} alt="Check box" />
      <span className="platform-text ms-2">{text}</span>
    </div>
  );
};

const SkillCard = ({ card }) => {
  return (
    <div className="skill-card h-100 p-4">
      {/* Icon + Title */}
      <div className="d-flex align-items-center mb-3 w-100">
        <div className="me-3 col-auto">
          <img src={card.icon} alt="icon" />
        </div>
        <h6 className="mb-0 plus-sans FS24FW500 fw-700 to-unset-transform col-9">
          {card.title}
        </h6>
      </div>

      {/* Content */}
      <div className="quote-para FS16FW500" style={{ lineHeight: "28px" }}>
        {typeof card.content === "string"
          ? ReactHtmlParser(card.content)
          : card.content}
      </div>
    </div>
  );
};

export default ExamVoucher;
